
import { Component } from "vue-property-decorator";
import OverviewCellBase from "@/app/dynamic-components/overviews/cells/overview-cell.base";
import { getObjectContentsFromPath } from "@/app/helpers/stringpath.helper";

@Component({
  components: {},
})
export default class OverviewCellFilename extends OverviewCellBase {
  public cellText(): any {
    if (this.value === null || this.value === undefined) return "-";

    if (this.metadata["translated"]) {
      return this.$t(this.value);
    }

    const extension = this.cellExtention();
    return this.value.replaceAll("." + extension, "");
  }

  public cellExtention(){
    const spliter = (this.value || '').split('.');
    if(spliter.length <= 1) return "";
    return spliter[spliter.length - 1].toLowerCase();
  }

  public cellIcon(): any {
    if (this.value === null || this.value === undefined || typeof this.value !== 'string') return "mdi-file-question-outline";

    const spliter = (this.value || '').split('.');
    if(spliter.length <= 1) return "mdi-file-question-outline";
    const extension = spliter[spliter.length - 1].toLowerCase();

    switch (extension) {
      // Image files
      case "png":
      case "jpeg":
      case "gif":
      case "jpg":
      case "bmp":
      case "tiff":
      case "tif":
      case "svg":
      case "webp":
        return "mdi-file-image-outline";

      // Microsoft Word documents
      case "doc":
      case "docx":
      case "docm":
      case "dot":
      case "dotx":
      case "dotm":
      case "rtf":
        return "mdi-file-word-outline";

      // Microsoft Excel spreadsheets
      case "xls":
      case "xlsx":
      case "xlsm":
      case "xlt":
      case "xltx":
      case "xltm":
      case "csv":
        return "mdi-file-excel-outline";

      // Microsoft PowerPoint presentations
      case "ppt":
      case "pptx":
      case "pptm":
      case "pot":
      case "potx":
      case "potm":
      case "pps":
      case "ppsx":
      case "ppsm":
        return "mdi-file-powerpoint-outline";

      // PDF files
      case "pdf":
        return "mdi-file-document-multiple-outline";

      // Text files
      case "txt":
      case "text":
      case "md":
      case "markdown":
        return "mdi-file-document-outline";

      // Code files
      case "html":
      case "htm":
      case "xml":
      case "css":
      case "js":
      case "ts":
      case "jsx":
      case "tsx":
      case "json":
      case "py":
      case "java":
      case "c":
      case "cpp":
      case "cs":
      case "php":
      case "rb":
      case "go":
      case "swift":
      case "kt":
        return "mdi-file-code-outline";

      // Archive files
      case "zip":
      case "rar":
      case "7z":
      case "tar":
      case "gz":
      case "bz2":
        return "mdi-folder-zip";

      // Audio files
      case "mp3":
      case "wav":
      case "ogg":
      case "flac":
      case "aac":
      case "wma":
        return "mdi-file-music";

      // Video files
      case "mp4":
      case "avi":
      case "mov":
      case "wmv":
      case "mkv":
      case "flv":
      case "webm":
        return "mdi-file-video";

      // Database files
      case "db":
      case "sql":
      case "sqlite":
      case "mdb":
      case "accdb":
        return "mdi-database";

      // Executable files
      case "exe":
      case "msi":
      case "bat":
      case "cmd":
      case "sh":
      case "app":
        return "mdi-application";

      // Font files
      case "ttf":
      case "otf":
      case "woff":
      case "woff2":
      case "eot":
        return "mdi-format-font";

      // Default for unknown extensions
      default:
        return "mdi-file-outline";
    }
  }

  iconColor(): string {
    return this.metadata["color"] ? this.metadata["color"] : "primary";
  }

  protected PostResolveValue() {
    if(this.metadata.template){
      this.value = this.overviewContext.resolvePlaceholders(this.metadata.template)
      if(this.value && typeof this.value === 'string') this.value = this.value.replaceAll('$nan','');
    }

    if (this.metadata?.translateList && this.value) {
      //entry in dataresolver
      let path = this.metadata.translateList;
      if (path.startsWith("data.")) {
        path = path.replace("data.", "");
      }
      const resolvedItems = getObjectContentsFromPath(
        path,
        this.additionalMetadata
      );
      if (Array.isArray(resolvedItems)) {
        resolvedItems
          .filter((it) => {
            return this.value === it[this.metadata.itemValue];
          })
          .forEach((value) => {
            this.value = value[this.metadata.itemText];
          });
      }
    }
  }
}
